export default __webpack_public_path__ + "206534c7ca0320aaf19672d65455498f.png";